import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-night-add-item-form',
  templateUrl: './night-add-item-form.component.html',
  styleUrls: ['./night-add-item-form.component.scss']
})
export class NightAddItemFormComponent implements OnInit {

  constructor() { }
  
  ngOnInit() {}
}
